import { render, staticRenderFns } from "./foodMenu.vue?vue&type=template&id=4f6f675d&"
import script from "./foodMenu.vue?vue&type=script&lang=js&"
export * from "./foodMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports